<template>

  <div id="header">
            <nav class="navbar navbar-expand-lg navbar-light">
                <router-link to="/" class="navbar-brand">
                    <img src="../assets/img/logo_colored_skanticket.png" alt="" srcset="">
                </router-link>
                <button class="navbar-toggler" data-target="#menu" data-toggle="collapse" aria-controls="menu" aria-expanded="false" aria-label="Toggle navigation">
                    <span class="navbar-toggler-icon"></span>
                </button>
                <div id="menu" class="collapse navbar-collapse">
                    <ul class="navbar-nav mr-auto">
                        <li class="nav-item">
                            <router-link to="/evenement/CINEMA" class="nav-link">
                                Cinema<span class="sr-only">(current)</span>
                            </router-link>
                        </li>
                        <li class="nav-item">
                            <router-link to="/evenement/EVENEMENTS" class="nav-link">
                                Concerts & Rencontres<span class="sr-only">(current)</span>
                            </router-link>
                        </li>
                        <li class="nav-item dropdown">
                                <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        Organiser
                                </a>
                                <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                                    <router-link to="/avantage" class="dropdown-item">
                                        Fonctionnalités
                                    </router-link>
                                    <router-link to="/tarif" class="dropdown-item">
                                        Tarif
                                    </router-link>
                                    <router-link to="/faq" class="dropdown-item">
                                        FAQ
                                    </router-link>
                                </div>
                        </li>
                        <li class="nav-item">
                            <router-link to="/apropos" class="nav-link">
                                A propos<span class="sr-only">(current)</span>
                            </router-link>
                        </li>

                    </ul>
                    <div id="navbarActionsBtn">
                        <a class="btn btn-darkblue font-weight-bold" href="https://billeterie.skanticket.com/inscription" role="button">Creer une billetterie</a>
                        <a class="btn btn-outline-primary" href="https://billeterie.skanticket.com" role="button">
                            <i class="fa fa-user-circle" aria-hidden="true"></i> 
                            Connexion
                        </a>
    
                    </div>
                </div>
            </nav>
    </div>

</template>

<script lang="js">
  export default  {
    name: 'entete',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {

    }
}
</script>


